import { render } from "./DeniedButtom.vue?vue&type=template&id=111d3b10&scoped=true"
import script from "./DeniedButtom.vue?vue&type=script&lang=js"
export * from "./DeniedButtom.vue?vue&type=script&lang=js"

import "./DeniedButtom.vue?vue&type=style&index=0&id=111d3b10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111d3b10"]])

export default __exports__